import InputBase from '@mui/material/InputBase';
import { styled } from '@mui/material/styles';
import { CSSProperties } from 'react';

export type DisplayTypeface = {
  fontFamily?: CSSProperties['fontFamily'];
  fontWeight?: CSSProperties['fontWeight'];
  fontSize?: CSSProperties['fontSize'];
};

export const CenteredDisplayInput = styled(InputBase, {
  shouldForwardProp: prop => prop !== 'typeface',
})<{ typeface?: DisplayTypeface }>(({ typeface }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
  '& .MuiInputBase-input': {
    textAlign: 'center',
    fontFamily: typeface?.fontFamily,
    fontWeight: typeface?.fontWeight,
    fontSize: typeface?.fontSize,
    lineHeight: 1.1,
    width: '100%',
    padding: 0,
    backgroundColor: 'transparent',
  },
}));
